import styled from '@emotion/styled';

import { Value } from '@/components/layouts/Race/RaceCard/Partials/HighlightValue/style';
import { BorderData } from '@/components/layouts/Race/RaceCard/style';
import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const Container = styled(BorderData)(() =>
  mq({
    fontSize: defaultTheme.font.size.xs,
    textAlign: 'left',
    padding: `0 ${defaultTheme.spacing.s}`,
    whiteSpace: 'nowrap',
  }),
);

export const RacerName = styled.span(() =>
  mq({
    fontSize: defaultTheme.font.size.s,
    textDecorationLine: 'underline',
    fontWeight: 'bold',
    marginRight: '2px',
  }),
);

export const RacerInfoDetail = styled.p(() =>
  mq({
    lineHeight: defaultTheme.font.height.s,
    marginTop: defaultTheme.spacing.xs,
  }),
);

export const PrefectureValue = styled(Value)(() =>
  mq({
    paddingLeft: 0,
  }),
);
